import { render, staticRenderFns } from "./MagSubMenuItem.vue?vue&type=template&id=7074ea81&scoped=true"
import script from "./MagSubMenuItem.vue?vue&type=script&lang=js"
export * from "./MagSubMenuItem.vue?vue&type=script&lang=js"
import style0 from "./MagSubMenuItem.vue?vue&type=style&index=0&id=7074ea81&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074ea81",
  null
  
)

export default component.exports